import React, { Component } from "react";
import { connect } from "react-redux";
import Showinterest from "../Components/ShowInterest";
import { kepInTouch } from "../../Client/action";
import { close_snack_bar } from "../snackbar/action";

export class Controller extends Component {
  render() {
    return <Showinterest {...this.props} />;
  }
}
export const mapStateToProps = (store) => {
  return {
    login: store.login,
    loader: store.loader,
    snackbar: store.snackbar,
    client: store.client,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    kepInTouch: (
      firstName,
      lastName,
      mobile,
      email,
      pincode,
      dealer,
      consentChecked,
      carType
    ) => {
      dispatch(
        kepInTouch(
          firstName,
          lastName,
          mobile,
          email,
          pincode,
          dealer,
          consentChecked,
          carType
        )
      );
    },
    close_snack_bar: () => {
      dispatch(close_snack_bar());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
